<template>
  <div class="container">
  <div class="item-1"></div>
  <div class="item-2"></div>
  <div class="item-3"></div>
  <div class="item-4"></div>
  <div class="item-5"></div>
</div>
</template>
<script setup>

</script>
<style lang="less" scoped>

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  overflow: hidden;
  animation-delay: 1s;
}

.item-1 {
  width: 10px;
  height: 10px;

  border-radius: 50%;
  background-color: var(--blue300);
  margin: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
    75% {
    transform: scale(2.5);
  }
  78%, 100% {
    opacity: 0;
  }
}
.item-1:before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--blue400);
  opacity: 0.7;
  animation: scale 2s infinite cubic-bezier(0, 0, 0.49, 1.02);
  animation-delay: 200ms;
  transition: 0.5s all ease;
  transform: scale(1);
}

.item-2 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color:  var(--blue400);
  margin: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
    75% {
    transform: scale(2.5);
  }
  78%, 100% {
    opacity: 0;
  }
}
.item-2:before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--blue500);
  opacity: 0.7;
  animation: scale 2s infinite cubic-bezier(0, 0, 0.49, 1.02);
  animation-delay: 400ms;
  transition: 0.5s all ease;
  transform: scale(1);
}

.item-3 {
  width: 10px;
  height: 10px;
  background: var(--blue500);
  border-radius: 50%;
  margin: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
    75% {
    transform: scale(2.5);
  }
  78%, 100% {
    opacity: 0;
  }
}
.item-3:before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color:  var(--blue600);
  opacity: 0.7;
  animation: scale 2s infinite cubic-bezier(0, 0, 0.49, 1.02);
  animation-delay: 600ms;
  transition: 0.5s all ease;
  transform: scale(1);
}

.item-4 {
  width: 10px;
  height: 10px;
  background: var(--blue600);
  border-radius: 50%;
  margin: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
    75% {
    transform: scale(2.5);
  }
  78%, 100% {
    opacity: 0;
  }
}
.item-4:before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--blue400);
  opacity: 0.7;
  animation: scale 2s infinite cubic-bezier(0, 0, 0.49, 1.02);
  animation-delay: 800ms;
  transition: 0.5s all ease;
  transform: scale(1);
}

.item-5 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color:  var(--blue700);
  margin: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
    75% {
    transform: scale(2.5);
  }
  78%, 100% {
    opacity: 0;
  }
}
.item-5:before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color:  var(--blue300);
  opacity: 0.7;
  animation: scale 2s infinite cubic-bezier(0, 0, 0.49, 1.02);
  animation-delay: 1000ms;
  transition: 0.5s all ease;
  transform: scale(1);
}
</style>